export default function () {
  if (this.$route.params.id) {
    this.loadItem()
  }
}
